import React from 'react'
import styled from 'styled-components'

import useCountdown from '../../hooks/useCountdown'

const Component = styled.div`
`

// TODO: can put back countdown.days if needed
const getLabel = countdown => {
  return `${countdown.hours} : ${countdown.minutes} : ${countdown.seconds}`
}

const NewCardDeadline = ({ deadline }) => {
  const countdown = useCountdown({
    deadline
  })

  return (
    <Component>
      {getLabel(countdown)}
    </Component>
  )
}

export default NewCardDeadline
